import Vue from 'vue'

Vue.mixin({
    methods: {
        currency(value) {
            return Vue.filter("currency")(value)
        },
        pluralize(value, options = []) {
            return Vue.filter("pluralize")(value, options)
        },
    }
})